import React from "react";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enUS as dateFnsLocaleEn } from "date-fns/locale/en-US";
import { pl as dateFnsLocalePl } from "date-fns/locale/pl";
import { theme } from "src/theme/theme";

import useIsAhr from "src/utils/hooks/useIsAhr";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import { GlobalModalContextProvider } from "src/utils/GlobalModal/GlobalModalContext";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { getCompanyBaseBreadcrumbs } from "src/Pages/Company/routerHelper";
import { getLanguage } from "src/utils/Languages/LanguageContext";
import __ from "src/utils/Translations";
import { SelectedRowsProvider } from "./SelectedRowsProvider";
import { PendingBenefitsTable } from "./Table/PendingBenefitsTable";

export default function PendingBenefitsWrapper() {
  const companyId = useCompanyId();
  const companyName = useCompanyName();
  const isAhr = useIsAhr();

  const language = getLanguage();

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={language === "pl" ? dateFnsLocalePl : dateFnsLocaleEn}
    >
      <ThemeProvider theme={theme({ language })}>
        <GlobalModalContextProvider>
          <PageTitle
            heading={`${__(
              "Benefity oczekujące dla firmy"
            )} ${companyName} (ID: ${companyId})`}
            breadcrumbsHeading={__("Benefity oczekujące")}
            breadcrumbs={
              isAhr
                ? []
                : [...getCompanyBaseBreadcrumbs(companyId, companyName)]
            }
            pushToHistory
          />
          <SelectedRowsProvider>
            <PendingBenefitsTable />
          </SelectedRowsProvider>
        </GlobalModalContextProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
}
